import { createFileRoute } from "@tanstack/react-router";

import { RequireAuth } from "../features/auth/RequireAuth";
import { MyNotesPage } from "../features/person-notes/MyNotesPage";

export const Route = createFileRoute("/notes")({
  component: () => (
    <RequireAuth>
      {(user) => (
        <MyNotesPage uid={user.uid} email={user.email} signOut={user.signOut} />
      )}
    </RequireAuth>
  ),
});
